import { AcceptProjectInvitationWidget } from '../../widgets/AcceptProjectInvitationWidget';

export const AcceptInvitationPage = () => {
  return <AcceptProjectInvitationWidget />;
};
